document.addEventListener("DOMContentLoaded", function () {
  const contactForm = document.getElementById("contactForm");
  if (!contactForm) return;

  function validateForm() {
    const name = document.getElementById("name").value.trim();
    const email = document.getElementById("email").value.trim();
    const phone = document.getElementById("phone").value.trim();
    const message = document.getElementById("message").value.trim();

    if (!name || !email || !phone || !message) {
      throw new Error(contactVars.messages.required);
    }

    if (name.length < 2) {
      throw new Error(contactVars.messages.nameLength);
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      throw new Error(contactVars.messages.emailInvalid);
    }

    if (!/^[0-9+\-\s()]*$/.test(phone)) {
      throw new Error(contactVars.messages.phoneInvalid);
    }

    if (message.length < 10) {
      throw new Error(contactVars.messages.messageLength);
    }

    return { name, email, phone, message };
  }

  async function submitForm(formData) {
    const formSection = document.querySelector(".contact-form-section");
    const submitButton = contactForm.querySelector('button[type="submit"]');
    const originalText = submitButton.textContent;
    submitButton.textContent = contactVars.messages.sending;
    submitButton.disabled = true;

    try {
      const response = await fetch(contactVars.ajaxUrl, {
        method: "POST",
        body: new URLSearchParams({
          action: "contact_form",
          nonce: contactVars.nonce,
          ...formData,
        }),
      });

      const data = await response.json();

      if (data.success) {
        const successMessage = document.createElement("div");
        successMessage.className = "success-message";
        successMessage.innerHTML = `
          <h2>${data.data.message}</h2>
          <div class="success-icon">✓</div>
        `;
        formSection.innerHTML = ""; // Clear the form
        formSection.appendChild(successMessage);
      } else {
        throw new Error(data.data.message || contactVars.messages.error);
      }
    } catch (error) {
      showMessage(error.message, "error");
      submitButton.textContent = originalText;
      submitButton.disabled = false;
    }
  }

  function showMessage(message, type) {
    const existingMessage = document.querySelector(".form-message");
    if (existingMessage) {
      existingMessage.remove();
    }

    const messageDiv = document.createElement("div");
    messageDiv.className = `form-message ${type}`;
    messageDiv.textContent = message;
    contactForm.insertBefore(messageDiv, contactForm.firstChild);

    if (type === "error") {
      setTimeout(() => {
        messageDiv.remove();
      }, 5000);
    }
  }

  contactForm.addEventListener("submit", async function (e) {
    e.preventDefault();

    try {
      const formData = validateForm();
      await submitForm(formData);
    } catch (error) {
      showMessage(error.message, "error");
    }
  });
});
